(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/definitions/topptipset.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/definitions/topptipset.js');
"use strict";

let makeXpertSizes;
let productIds;
let EventTypeId;
let constants;
let brandMapping;
if (svs.isServer) {
  constants = require('../constants.es6');
  makeXpertSizes = require('../utils/make-xpert-sizes.es6');
  productIds = require('@svenskaspelab/trinidad-core').core.components.require('utils', 'products').productIds;
  EventTypeId = require('../../../../../sportinfo/common/assets/javascripts/constants.es6').EventTypeId;
  brandMapping = require('../../../../../lb-utils/brand-mapping/assets/javascripts/brand-mapping.es6');
} else {
  makeXpertSizes = svs.components.tipsen.engine.utils.makeXpertSizes;
  productIds = svs.utils.products.productIds;
  EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
  constants = svs.components.tipsen.engine.constants;
  brandMapping = svs.components.lbUtils.brandMapping.fn;
}
const TypesRelatedProducts = {
  [constants.RelatedProductType.PIX]: {
    [productIds.T8STRYK]: productIds.FULLTRAFF,
    [productIds.T8]: null,
    [productIds.T8EXTRA]: null
  }
};
const topptipsetDefinition = {
  competitions: [],
  outcomes: {
    eventTypeId: EventTypeId.EVENT_1X2,
    outcomeCount: 3,
    outcomeGroupCount: 1,
    outcomeHeatmap: {}
  },
  rSystems: [],
  uSystems: [],
  reduction: [],
  systems: [constants.systems.SYSTEM_MSYS],
  betAmounts: [1, 2, 3, 5, 10],
  maxBetAmount: 10,
  weeks: [1],
  sportkryssFactors: [0],
  sportkryssBase: 10,
  addonPixSize: [0, 16, 32, 64],
  maxSystemSize: 4374,
  drawProductIds: [productIds.T8, productIds.T8EXTRA, productIds.T8STRYK],
  xpertMsys: makeXpertSizes(8, 8, 2, 972),
  xpertMsysSpecialValues: [16, 24, 32, 36, 64, 81, 96, 192, 243],
  quickPlayPixSizes: [16, 48, 72, 108, 144, 192, 216, 384],
  displayName: brandMapping.getProductDisplayName(productIds.T8),
  brandName: brandMapping.getSiteBrand(productIds.T8),
  brandLogo: brandMapping.getProductBrand(productIds.T8),
  getDisplayNameByDraw: draw => brandMapping.getProductDisplayNameByDraw(draw, productIds.T8),
  getBrandNamesByDraw: draw => brandMapping.getProductBrandsByDraw(draw, productIds.T8),
  getBrandLogoByDraw: draw => brandMapping.getProductBrandByDraw(draw, productIds.T8),
  getBrandMenuColorByDraw: draw => brandMapping.getProductBrandMenuColorByDraw(draw, productIds.T8),
  getProductBrandByDraw: draw => brandMapping.getProductBrandByDraw(draw, productIds.T8),
  maxExternalSystemSize: 4374,
  features: {
    marketplace: true,
    singles: true
  },
  getRelatedProduct: (type, productId) => TypesRelatedProducts[type][productId],
  getTransfer: draw => {
    if (draw.productId === productIds.T8) {
      return null;
    }
    return {
      product: draw.productId === productIds.T8STRYK ? productIds.STRYKTIPSET : productIds.EUROPATIPSET,
      drawsApi: draw.productId === productIds.T8STRYK ? 'stryktipset' : 'europatipset'
    };
  },
  pixSystems: [],
  minGroupAmount: 10,
  minStake: 1,
  hasGuaranteedJackpot: false,
  hasJackpot: false,
  tipsinfoSupport: [constants.TipsinfoTypes.Odds, constants.TipsinfoTypes.StartOdds, constants.TipsinfoTypes.SvenskaFolket, constants.TipsinfoTypes.Matchstart, constants.TipsinfoTypes.Favourites, constants.TipsinfoTypes.Mutuals, constants.TipsinfoTypes.Analys, constants.TipsinfoTypes.Compressed],
  tipsinfoSupportResult: [constants.TipsinfoTypes.Odds, constants.TipsinfoTypes.SvenskaFolket, constants.TipsinfoTypes.Favourites],
  tipsinfoSupportMyBets: [constants.TipsinfoTypes.Odds, constants.TipsinfoTypes.SvenskaFolket, constants.TipsinfoTypes.Favourites],
  loadDrawsApiPath: 'topptipsetfamily',
  moduleEngine: 'topptipset',
  defaultCouponValues: {
    betAmount: 1,
    pixSize: 48,
    reduceModeCount: undefined
  },
  pixType: '1X2',
  pixSystem: constants.PixSystem.Xperten,
  externalChunkSize: {
    SROW: 1000,
    MSYS: 100,
    SROW_MARKETPLACE_GROUP: 1000,
    MSYS_MARKETPLACE_GROUP: 100 
  },
  couponSettings: [constants.coupon.Compressed],
  maxWagerAmount: 0,
  maxSelectionOutcomeGroup: 0
};
if (svs.isServer) {
  module.exports = topptipsetDefinition;
} else {
  setGlobal('svs.components.tipsen.engine.definitions.topptipset', topptipsetDefinition);
}

 })(window);